"use client"

import { useTransition } from "react"
import { useRouter } from "next/navigation"

interface Props {
  effectiveUserName: string
  effectiveRole: "partner" | "student"
}

export function ImpersonationBanner({ effectiveUserName }: Props) {
  const [pending, startTransition] = useTransition()
  const router = useRouter()

  function handleStop() {
    startTransition(async () => {
      await fetch("/api/admin/impersonation/stop", { method: "POST" })
      router.push("/admin")
    })
  }

  return (
    <div className="text-body-sm flex w-full shrink-0 items-center justify-between bg-brand-700 px-6 py-2 text-white">
      <span>
        Visualizando como{" "}
        <span className="font-semibold">{effectiveUserName}</span>
      </span>
      <button
        onClick={handleStop}
        disabled={pending}
        className="font-medium underline underline-offset-2 transition-opacity hover:opacity-80 disabled:opacity-50"
      >
        {pending ? "Saindo..." : "Sair do modo"}
      </button>
    </div>
  )
}
